import React, { useEffect, useState } from 'react';
import { Slider } from 'antd';
import { connect } from 'react-redux';
import * as advanceActions from '../../../redux/actions/advancedSearch';
import * as suppliersActions from '../../../redux/actions/selectionOfSuppliers';
import api from '../../../helpers/api';
// import { getOkpd2FromLS, getOkatoFromLS, setOkpd2ToLS, setOkatoToLS } from '../../../helpers/localStorage';
import Bin from '../../../assets/images/Bin.svg';
import style from './AdvancedSearch.module.scss';
import SelectComponent from '../SelectComponent';
import { IAdvancedSearch, IState } from '../../../types/interfaces';
import dataRegions from '../../../assets/data-regions';

interface IProps {
  setOkpd2: (payload: string[]) => void;
  // setRegions: (payload: string[]) => void;
  setRadius: (payload: number) => void;
  setRpn: (payload: number) => void;
  // setSortParticipation: (payload: number) => void;
  // setSortVictories: (payload: number) => void;
  setMsp: (payload: number) => void;
  clear: () => void;
  options: IAdvancedSearch;
  setLimit: (payload: number) => void;
  okpd2Value: string[];
  // okadoValues: string[];
  setProcedureBidsCountBuyer: (payload: number) => void;
  setBidsRegionProcedureBidsCount: (payload: number) => void;
  setTagsProcedureBidsCount: (payload: number) => void;
  setOKPD2WonProcedureBidsCount: (payload: number) => void;
  // setLinkedBuyerDescription: (payload: string) => void;
  regionsByInn: string[];
  setRegionsByInn: (payload: string[]) => void;
  bidsRegions: string[];
  setBidsRegions: (payload: string[]) => void;
}

type Regions = {
  title: string;
  value: string;
};

const marks = {
  0: '',
  50: '50 км',
  100: '100 км',
  150: '150 км',
  200: '200 км',
  250: '250 км',
  300: '300 км',
  350: '350 км',
  400: '400 км',
  450: '450 км',
  500: '',
};
const AdvancedSearch = ({
  setOkpd2,
  // setRegions,
  setRadius,
  setRpn,
  // setSortParticipation,
  // setSortVictories,
  setMsp,
  options,
  clear,
  setLimit,
  okpd2Value,
  // okadoValues,
  setProcedureBidsCountBuyer,
  setBidsRegionProcedureBidsCount,
  setTagsProcedureBidsCount,
  setOKPD2WonProcedureBidsCount,
  // setLinkedBuyerDescription,
  regionsByInn,
  setRegionsByInn,
  bidsRegions,
  setBidsRegions,
}: IProps) => {
  const [okpd2, setOkpd2Data] = useState<{ title: string; value: string }[]>([]);
  const [regions, setRegionsData] = useState<{ title: string; value: string }[]>([]);
  // new 29.03.2023 - на данный момент локальный массив с кодами и названиями регионов
  const [regiosCode, setRegionsCode] = useState<{ title: string, value: string }[]>([]);
  const timerIdRegions = React.useRef<any>(null);
  const timerIdOkpd2 = React.useRef<any>(null);
  const timerRegionCode = React.useRef<any>(null);
  // Актуальные значения у инпутов нам нужны для того чтобы
  // при его закрытии (при закрытии поле очищается), мы делали запрос
  // на получение дефолтного списка значений
  const [curRegion, setCurRegion] = useState('');
  const [curOkpd2, setCurOkpd2] = useState('');
  const [curRegionCode, setCurRegionCode] = useState('');

  const convertDataRegionsCode = (arr: Regions[]) => {

    const filterArray = arr.map((region) => (
      {
        value: `${region.value} ${region.title}`,
        title: region.title,
      }
    ));
    return filterArray;
  };

  const changeDisplayRegions = (arr: Regions[]) => {
    arr.map((region) => {
      const titleArray = region.title.split(' ');
      const isContainsCode = Number(titleArray[0]);
      if (isContainsCode) {
        titleArray.push(String(titleArray.splice(0, 1)));
        // eslint-disable-next-line no-param-reassign
        region.title = titleArray.join(' ');
      }
      return region;
    });
    return arr;
  };
  const debounceGetRegionsCode = (query?: string, amount?: number) => {
    const searchString = query?.toLowerCase();
    if (timerRegionCode.current) {
      clearTimeout(timerRegionCode?.current);
    }
    timerRegionCode.current = setTimeout(() => {
      const filterRegions = convertDataRegionsCode(dataRegions).filter(region =>
        region.title.toLowerCase().includes(searchString ?? '') || region.value.toLowerCase().includes(searchString ?? ''));
      setRegionsCode(filterRegions);
    }, amount ?? 1000);
  };
  const debounceGetRegions = (query?: string, amount?: number) => {
    if (timerIdRegions.current) {
      clearTimeout(timerIdRegions?.current);
    }
    timerIdRegions.current = setTimeout(() => {
      api.getOkatoRegionData(query, amount).then((res) => setRegionsData(changeDisplayRegions(res)));
    }, 1000);
  };

  const debounceGetOkpd2 = (query?: string, amount?: number) => {
    if (timerIdOkpd2.current) {
      clearTimeout(timerIdOkpd2?.current);
    }
    timerIdOkpd2.current = setTimeout(() => {
      api.getOkpd2Data(query, amount).then((res) => setOkpd2Data(res));
    }, 1000);
  };

  useEffect(() => {
    if (curRegion === '') {
      debounceGetRegions('', 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curRegion]);

  useEffect(() => {
    if (curOkpd2 === '') {
      debounceGetOkpd2('', 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curOkpd2]);

  useEffect(() => {
    api.getOkatoRegionData('', 100).then((res) => setRegionsData(changeDisplayRegions(res)));
    api.getOkpd2Data('', 100).then((res) => setOkpd2Data(res));


    const newData: Regions[] = convertDataRegionsCode(dataRegions);
    setRegionsCode(newData);

    // Для удаления кэша предыдущей реализации
    localStorage.removeItem('okpd2');
    localStorage.removeItem('okato');
  }, []);
  useEffect(() => {
    if (curRegionCode === '') {
      debounceGetRegionsCode('', 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curRegionCode]);

  // useEffect(() => {
  // const okpd2Data = getOkpd2FromLS();
  //   const okatoData = getOkatoFromLS();
  //   // Эт мы берем из локалстора если там есть данные
  //   // api.getOkatoRegionData('Южны');
  //   if (okpd2Data) {
  //     setOkpd2Data(JSON.parse(okpd2Data));
  //   } else {
  //     // Вот запрос
  //     api.getOkpd2Data().then((res) => {
  //       setOkpd2ToLS(JSON.stringify(res));
  //       // Тут кладем в стор
  //       setOkpd2Data(res);
  //     });
  //   }

  //   if (okatoData) {
  //     const data = JSON.parse(okatoData);
  //     setRegionsData(changeDisplayRegions(data));
  //   } else {
  //     api.getRegionsData().then((res) => {
  //       setOkatoToLS(JSON.stringify(res));
  //       setRegionsData(res);
  //     });
  //   }
  // }, []);

  return (
    <div className={style.form}>
      <fieldset className={style.formItem}>
        <legend className={style.legend}>Код классификатора ОКДП2</legend>
        <div className={style.description}>
          Код ОКПД2 может соответствовать профилю деятельности поставщика или номенклатуре закупки
        </div>
        <SelectComponent
          setCurValue={setCurOkpd2}
          noSearch="Код не найден"
          treeData={okpd2}
          cb={setOkpd2}
          cbSearch={debounceGetOkpd2}
          holder="Введите название или код позиции..."
          value={okpd2Value}
        />
      </fieldset>
      <fieldset className={style.formItem}>
        <legend className={style.legend}>Регион поставки</legend>
        <SelectComponent
          setCurValue={setCurRegion}
          noSearch="Регион не найден"
          treeData={regions}
          cb={setBidsRegions}
          cbSearch={debounceGetRegions}
          holder="Введите название региона или код ОКАТО..."
          // value={okadoValues}
          value={bidsRegions}
        />
      </fieldset>
      <fieldset className={style.formItem}>
        <legend className={style.legend}>Регион регистрации поставщика</legend>
        <SelectComponent
          setCurValue={setCurRegionCode}
          noSearch="Регион не найден"
          treeData={regiosCode}
          cb={setRegionsByInn}
          cbSearch={debounceGetRegionsCode}
          holder="Введите название региона или код ОКАТО..."
          value={regionsByInn}
        />
      </fieldset>
      {/*  */}
      <fieldset className={style.formItem}>
        <legend className={style.legend}>Расширение поиска по региону</legend>
        <Slider
          marks={marks}
          defaultValue={options.regions_expansion_radius}
          value={options.regions_expansion_radius}
          max={500}
          step={50}
          handleStyle={{ borderColor: '#009EE3', backgroundColor: '#009EE3' }}
          onChange={setRadius}
        />

      </fieldset>
      <div className={`${style.formItem}`}>
        <legend className={style.legend}>Количество результатов поиска</legend>
        <div className={style.tabs}>
          <input
            id="50"
            type="radio"
            className={style.tabsInput}
            name="resultCount"
            value="50"
            aria-label="radio-button"
            checked={options.limit === 50}
            onChange={() => setLimit(50)}
          />
          <label htmlFor="50" className={style.tabsLabel}>
            50
          </label>
          <input
            id="100"
            type="radio"
            className={style.tabsInput}
            name="resultCount"
            value="100"
            aria-label="radio-button"
            checked={options.limit === 100}
            onChange={() => setLimit(100)}
          />
          <label htmlFor="100" className={style.tabsLabel}>
            100
          </label>
          <input
            id="250"
            type="radio"
            className={style.tabsInput}
            name="resultCount"
            value="250"
            aria-label="radio-button"
            checked={options.limit === 250}
            onChange={() => setLimit(250)}
          />
          <label htmlFor="250" className={style.tabsLabel}>
            250
          </label>
          <input
            id="500"
            type="radio"
            className={style.tabsInput}
            name="resultCount"
            value="500"
            aria-label="radio-button"
            checked={options.limit === 500}
            onChange={() => setLimit(500)}
          />
          <label htmlFor="500" className={style.tabsLabel}>
            500
          </label>
          <input
            id="1000"
            type="radio"
            className={style.tabsInput}
            name="resultCount"
            value="1000"
            aria-label="radio-button"
            checked={options.limit === 1000}
            onChange={() => setLimit(1000)}
          />
          <label htmlFor="1000" className={style.tabsLabel}>
            1000
          </label>
        </div>
      </div>
      <fieldset className={`${style.formItem}`}>
        <div className={`${style.checkboxes}`}>
          <fieldset className={style.rpnFieldset}>
            <legend className={style.legend}>Включая РНП</legend>
            <div className={style.checkboxesGroup}>
              <label className={style.input}>
                <input
                  className={style.inputInput}
                  type="radio"
                  name="rpn"
                  checked={!options.exclude_dishonest}
                  onChange={() => setRpn(0)}
                />
                <span className={style.inputCheckmark} />
                <span className={style.inputLabel}>Да</span>
              </label>
              <label className={style.input}>
                <input
                  className={style.inputInput}
                  type="radio"
                  name="rpn"
                  checked={!!options.exclude_dishonest}
                  onChange={() => setRpn(1)}
                />
                <span className={style.inputCheckmark} />
                <span className={style.inputLabel}>Нет</span>
              </label>
            </div>
          </fieldset>
          <fieldset>
            <legend className={style.legend}>Только МСП</legend>
            <div className={style.checkboxesGroup}>
              <label className={style.input}>
                <input
                  className={style.inputInput}
                  type="radio"
                  name="msp"
                  checked={!!options.is_msp}
                  onChange={() => setMsp(1)}
                />
                <span className={style.inputCheckmark} />
                <span className={style.inputLabel}>Да</span>
              </label>
              <label className={style.input}>
                <input
                  className={style.inputInput}
                  type="radio"
                  name="msp"
                  checked={!options.is_msp}
                  onChange={() => setMsp(0)}
                />
                <span className={style.inputCheckmark} />
                <span className={style.inputLabel}>Нет</span>
              </label>
            </div>
          </fieldset>
        </div>

      </fieldset>
      <div className={`${style.formItem}`}>
        <fieldset className={`${style.checkboxes}`}>
          <fieldset className={style.rpnFieldset}>
            <legend className={style.legend}>Сортировать по: </legend>
            <div className={style.description}>
              Первыми в сформированном списке будут указаны участники, наиболее соответствующие заданным параметрам
            </div>
            <div className={style.filters}>
              <div>
                <div className={style.filter}>
                  <label className={style.input}>
                    <input
                      className={style.inputInput}
                      type="checkbox"
                      name="sort"
                      checked={!!options.relevance.okpd2_won_procedure_bids_count}
                      onChange={() => setOKPD2WonProcedureBidsCount(!options.relevance.okpd2_won_procedure_bids_count ? 100 : 0)}
                    />
                    <span className={style.inputCheckmark} />
                    <span className={style.inputLabel}>Кол-ву участий в закупках по ОКПД2</span>
                  </label>
                </div>
                <div className={style.filter}>
                  <label className={style.input}>
                    <input
                      className={style.inputInput}
                      type="checkbox"
                      name="sort"
                      checked={!!options.relevance.tags_procedure_bids_count}
                      onChange={() => setTagsProcedureBidsCount(!options.relevance.tags_procedure_bids_count ? 100 : 0)}
                    />
                    <span className={style.inputCheckmark} />
                    <span className={style.inputLabel}>Кол-ву участий в закупках по ключевым словам</span>
                  </label>
                </div>
              </div>
              <div>
                <div className={[style.checkboxesGroup, style.filter].join(' ')}>
                  <label className={style.input}>
                    <input
                      className={style.inputInput}
                      type="checkbox"
                      name="sort"
                      checked={!!options.relevance.bids_region_procedure_bids_count}
                      onChange={() => setBidsRegionProcedureBidsCount(!options.relevance.bids_region_procedure_bids_count ? 100 : 0)}
                    />
                    <span className={style.inputCheckmark} />
                    <span className={style.inputLabel}>Кол-ву участий в закупках в регионе</span>
                  </label>
                </div>
                <div>
                  <label className={style.input}>
                    <input
                      className={style.inputInput}
                      type="checkbox"
                      name="sort"
                      checked={!!options.relevance.procedure_bids_count_for_buyer}
                      onChange={() => setProcedureBidsCountBuyer(!options.relevance.procedure_bids_count_for_buyer ? 100 : 0)}
                    />
                    <span className={style.inputCheckmark} />
                    <span className={style.inputLabel}>Кол-ву участий в закупках Организатора</span>
                  </label>
                </div>
              </div>
            </div>
          </fieldset>
        </fieldset>
      </div>
      {/*  */}

      <button type="button" aria-label="Очистить" className={style.clean} onClick={clear}>
        <img src={Bin} alt="Корзина" />
        Очистить
      </button>
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  options: state.advancedSearch,
  page: state.selectionOfSuppliers.current_page,
  okpd2Value: state.advancedSearch.okpd2_codes,
  okadoValues: state.advancedSearch.regions,
  regionsByInn: state.advancedSearch.regions_by_inn,
  bidsRegions: state.advancedSearch.bids_regions,
});

export default connect(mapStateToProps, { ...advanceActions, ...suppliersActions })(AdvancedSearch);
